import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginForm from '../components/Login/LoginForm';

const Login = () => {
  const { login, isLoading, error, clearError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/explore';

  const handleLogin = async (formData) => {
    try {
      const result = await login(formData.email, formData.password);

      if (result.success) {
        clearError();
        navigate(from, { replace: true });
      }
    } catch (err) {
      // Logic preserved: Errors are handled by the AuthContext/LoginForm
    }
  };

  return (
    <div className="w-full bg-white">
      <LoginForm 
        onLogin={handleLogin} 
        isLoading={isLoading}
        loginError={error}
      />
    </div>
  );
};

export default Login;